import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { SelectComponent } from '@blaze-shared/shared-feature';
import { ButtonIconComponent } from '@blaze-shared/shared-ui';
import { SelectOption } from '@blaze-shared/shared-util';

import {
  ApiBuilderParameterExtended,
  ParameterPaginationMethod,
  ParametersExtendedForm,
  type ParametersExtendedFormArray,
  ParameterType,
} from '../api-builder.model';
import { updateDynamicFormControls } from '../utils/api-builder-utils';

@Component({
  selector: 'blaze-parameters-list-extended',
  imports: [
    ButtonIconComponent,
    FormsModule,
    MatButtonToggleModule,
    MatIconModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    SelectComponent,
  ],
  templateUrl: './parameters-list-extended.component.html',
  styleUrls: ['./parameters-list-extended.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParametersListExtendedComponent implements OnInit, OnChanges {
  @Input() label = '';
  @Input() formCtrl!: ParametersExtendedFormArray;
  @Input() parameters: ApiBuilderParameterExtended[] = [];

  readonly ParameterType = ParameterType;
  readonly ParameterPaginationMethod = ParameterPaginationMethod;
  paginationMethods!: SelectOption<ParameterPaginationMethod>[];

  constructor() {
    this.paginationMethods = [
      { value: ParameterPaginationMethod.PageNumber, label: 'Page Number' },
      { value: ParameterPaginationMethod.PageSize, label: 'Page Size' },
      { value: ParameterPaginationMethod.RowOffset, label: 'Row Offset' },
    ];
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['parameters']) {
      return;
    }
    const params: ApiBuilderParameterExtended[] = changes['parameters'].currentValue;

    if (!this.formCtrl) {
      return;
    }
    this.updateForm(this.formCtrl, params);
  }

  ngOnInit(): void {
    this.updateForm(this.formCtrl, this.parameters);
  }

  updateForm(form: ParametersExtendedFormArray, params: ApiBuilderParameterExtended[]): void {
    updateDynamicFormControls(form, params, (param) => {
      const { name = '', value = '' } = param ?? {};
      return new FormGroup<ParametersExtendedForm>({
        name: new FormControl(name, { nonNullable: true }),
        value: new FormControl(value, { nonNullable: true }),
        type: new FormControl(ParameterType.Dynamic, { nonNullable: true }),
        paginationMethod: new FormControl(ParameterPaginationMethod.PageNumber),
        optional: new FormControl(false),
      });
    });
  }

  deleteParam(row: number): void {
    if (this.formCtrl.controls.length > 1) {
      this.formCtrl.removeAt(row);
    }
  }
}
